import { render, staticRenderFns } from "./OpcionesDropdownTableComponent.vue?vue&type=template&id=63ed7ada&scoped=true"
import script from "./OpcionesDropdownTableComponent.vue?vue&type=script&lang=js"
export * from "./OpcionesDropdownTableComponent.vue?vue&type=script&lang=js"
import style0 from "./OpcionesDropdownTableComponent.vue?vue&type=style&index=0&id=63ed7ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed7ada",
  null
  
)

export default component.exports